<template>
  <div>
    <!---用户注册弹窗-->
    <el-dialog
      :visible.sync="$root.registVisible"
      width="470px"
      :before-close="handleClose"
    >
      <div class="regist">
        <div class="box">
          <div class="regist-tit">用户注册</div>

          <div class="list" style="padding-top:30px">
            <el-form :model="registerForm" status-icon>
              <p class="hint-login">可使用老子云账号登录</p>
              <el-form-item prop="phone">
                <el-input
                  v-model.trim="registerForm.phone"
                  class="check-inp"
                  maxlength="11"
                  name="phone"
                  autocomplete="off"
                  placeholder="请输入手机号"
                >
                  <i slot="prefix" class="iconfont iconzhanghao icon" />
                </el-input>
                <div v-show="isRegist" class="register">
                  <p>该手机号码已注册,请</p>
                  <span @click="goLogin">直接登录</span>
                </div>
              </el-form-item>

              <div class="puzzle">
                <Puzzle @adopt="adopt" />
              </div>

              <sendCode
                ref="sendCode"
                v-model="registerForm.code"
                :phone="registerForm.phone"
                type="register"
                @getSmsKey="getSmsKey"
                @userIsRegist="userIsRegist"
              />
              <!-- <el-form-item>
                <el-input
                  v-model="registerForm.code"
                  placeholder="请输入短信验证码"
                  class="code_input"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  maxlength="6"
                  style="width:200px"
                  type="register"
                ></el-input>
                <span
                  class="get_code"
                  @click="sendSysCode('smsUpdatePassword')"
                  >{{ codeButtonText }}</span
                >
              </el-form-item> -->

              <el-form-item prop="password" class="hide-check-icon">
                <el-input
                  v-model.trim="registerForm.password"
                  class="check-inp"
                  :type="passForm.show.new ? 'text' : 'password'"
                  maxlength="16"
                  name="password"
                  autocomplete="off"
                  placeholder="请输入密码"
                >
                  <i
                    slot="suffix"
                    :class="
                      passForm.show.new
                        ? 'iconfont  iconyulan'
                        : 'iconfont  iconbiyanjing'
                    "
                    ref="confimPwdIcon"
                    @click="showNewPwd"
                  />
                  <i slot="prefix" class="iconfont  iconmima" ref="pwdIcon" />
                </el-input>
              </el-form-item>
              <el-form-item prop="professionCode">
                <el-select
                  v-model="registerForm.professionCode"
                  class="check-inp"
                  placeholder="请选择职业"
                  suffix-icon="el-icon-date"
                >
                  <template slot="prefix"
                    ><i class="iconfont iconzhiye"></i
                  ></template>

                  <el-option label="应用开发者" value="appdeveloper" />
                  <el-option label="模型师" value="modeler" />
                  <el-option label="设计师" value="designer" />
                  <el-option label="其他" value="other" />
                </el-select>
              </el-form-item>
            </el-form>

            <el-button
              round
              class="btn-blue lb"
              @click="regist"
              data-agl-cvt="5"
              >注册</el-button
            >

            <div class="helper" style="margin-top:25px;margin-bottom:30px">
              <div class="right">
                <span>已有账号?</span>
                <span style="color:#1458EA" @click="goLogin">返回登录</span>
              </div>
            </div>
            <!-- 底部微信注册和qq注册 -->
            <div class="t"><span>第三方注册</span></div>
            <div class="thirdLogin l-icon">
              <i class="iconfont iconweixin" @click="wechatHandleClick" />
              <i class="iconfont iconqq1" @click="tencentHandleClick" />
             
            </div>
          </div>
           <div @wechatHandleClick="wechatHandleClick">
                <div class="wxQrCode" v-show="isShowWx">
                  <div class="close" @click="isShowWx = false"></div>
                  <div class="circle"></div>
                  <div id="register_container"></div>
                </div>
              </div>
        </div>
      </div>
    </el-dialog>

    <!-- 注册成功弹窗 -->
    <div class="layout" v-show="showQrCode">
      <div class="inner">
        <h5>
          恭喜你，注册成功！<br />
          <!-- 扫码添加客服立即获取平台 <span style="color: #1458EA;">免费消费</span> 权益 -->
          {{ this.popupData.tipText }}
        </h5>
        <!-- <img :src="'https://laozi-auto-east.obs.cn-east-2.myhuaweicloud.com/QRCode/qrcode.png?time='+timestamp" /> -->
        <img
          :src="
            'https://laozi-autopublic-east.obs.cn-east-2.myhuaweicloud.com/' +
              this.popupData.img
          "
        />
        <p>扫一扫 即可免费获取</p>
        <button @click="jump">我知道了</button>
      </div>
    </div>

    <!-- 推广码组件 -->
    <invitationCode v-model="showCode" @handle="closeView" />
  </div>
</template>

<script>
import { validateCode, validatePhone, validatePwd } from "@/utils/validate";
import sendCode from "@/components/sendCode";
import Puzzle from "@/components/aliPuzzle";
import thirdLogin from "@/components/thirdLogin";
import agreement from "@/components/agreement";
import register from "@/components/register";
import invitationCode from "@/components/invitationCode";
import { mapMutations, mapState, mapActions } from "vuex";
import { api_registerPhone, api_appuserinfo,api_send_verificaCode, } from "@/api/login";
import Cookie from "js-cookie";
import userInfo from "@/mixins/userInfo";
export default {
  mixins: [userInfo],
  components: {
    sendCode,
    Puzzle,
    thirdLogin,
    agreement,
    register,
    invitationCode,
  },
  data() {
    return {
      codeTxt: "发送验证码",
      registerForm: {
        phone: "",
        password: "",
        code: "",
        professionCode: "",
      },
      rules: {
        phone: [{ validator: validatePhone, trigger: "blur" }],
        password: [{ validator: validatePwd, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }],
      },
      isRegist: false,
      verification: false,
      showCode: false,
      showQrCode: false,
      smsKey: "",
      isShowWx: false,
      timestamp: Date.now(),
      popupData: {
        img: "",
        status: "",
        tipText: "",
      },
      popupStatus: "",
      passForm: {
        oldPass: "",
        newPass: "",
        checkPass: "",
        show: {
          old: false,
          new: false,
          check: false,
        },
      },
      codeButtonText: "发送验证码",
      isReady: true,
      showCertification: false,
      userInfoRes: "",
    };
  },
  watch: {
    registerForm: {
      handler: function(n) {
        console.log(n);
        if (n.code) n.code = n.code.replace(/[^\d]/g, "");
        if (n.phone) n.phone = n.phone.replace(/[^\d]/g, "");
      },
      deep: true,
    },
  },
  mounted() {
    if (this.$route.query.phone)
      this.registerForm.phone = this.$route.query.phone;
    const _this = this;
    // document.onkeydown = function(e) {
    //   const key = window.event.keyCode;
    //   if (key === 13) {
    //     _this.regist(); //方法
    //   }
    // };
    this.getInfo();
    window._agl = window._agl || [];
    (function() {
      _agl.push(["production", "_f7L2XwGXjyszb4d1e2oxPybgD"]);
      (function() {
        var agl = document.createElement("script");
        agl.type = "text/javascript";
        agl.async = true;
        agl.src =
          "https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(agl, s);
      })();
    })();
  },
  created() {

  },
  //   created(){
  //       this.registerForm={
  //         phone: "",
  //         password: "",
  //         code: "",
  //         professionCode: "",
  //       };
  //   },
  //   beforeDestroy() {
  //     document.onkeydown = document.onkeydown = function(e) {
  //       e.defaultPrevented();
  //     };
  //   },
  methods: {

    //更换密码图标
    showNewPwd() {
      this.passForm.show.new = !this.passForm.show.new;
    },
    ...mapMutations({
      SETAUTHORIZATION: "login/SETAUTHORIZATION",
      ISLOGINTOASTSHOW: "login/ISLOGINTOASTSHOW",
      SETAGREEMENTPATH: "login/SETAGREEMENTPATH",
      SETISAGREE: "login/SETISAGREE",
      SETREGISTERDATA: "login/SETREGISTERDATA",
      ISREGISTER: "login/ISREGISTER",
      LOGINTOASTTYPE: "login/LOGINTOASTTYPE",
    }),
    ...mapActions("login", {
      GETUSERINFO: "GETUSERINFO",
    }),
    wechatHandleClick() {
      this.isShowWx = true;
      const appid =
        process.env.MODE == "pro"
          ? "wx14b9ed1bdad56d7c"
          : "wx14b9ed1bdad56d7c";

      const redirect_uri =
        process.env.MODE == "pro"
          ? encodeURIComponent("https://twinsearth.laozicloud.com")
          : encodeURIComponent("https://twinsearth.laozicloud.net");

      // const url = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_login&state=wechat#wechat_redirect`
      // // console.log(url)
      // window.location.href = url

      var obj = new WxLogin({
        self_redirect: false,
        id: "register_container",
        appid: appid,
        scope: "snsapi_login",
        redirect_uri: redirect_uri,
        state: "",
        style: "",
        href: "",
      });
      // this.$root.registVisible=false
      // this.$root.bindPhoneVisible=true
    },
    tencentHandleClick() {
      const client_id = "101468365";
      const redirect_uri =
        process.env.MODE == "pro"
          ? encodeURIComponent("https://twinsearth.laozicloud.com")
          : encodeURIComponent("https://twinsearth.laozicloud.net");
      const url = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=${client_id}&redirect_uri=${redirect_uri}&state=tencent`;
      window.location.href = url;
      // this.$root.registVisible=false
      // this.$root.bindPhoneVisible=true
    },
    //获取弹窗信息
    getPopupInfo() {
      this.axios
        .post("/api-personal/laozi/v3/common/unauth/getPopupSettings")
        .then((res) => {
          if (res.resp_code == 60000) {
            this.popupStatus = res.datas.status;
            if (this.popupStatus == 1) {
              this.$emit("handle");
            } else if (this.popupStatus == 0) {
              //    this.$router.push({ path: '/' })
              //  this.goReturnUrl()
            }
          } else {
            this.$message.error(res.resp_msg);
          }
        });
    },
    getSmsKey(val) {
      this.smsKey = val;
    },
    adopt() {
      this.verification = true;
      this.$refs.sendCode.getCode();
    },
    getInfo() {
      this.axios
        .post("/api-personal/laozi/v3/common/unauth/getPopupSettings")
        .then((res) => {
          if (res.resp_code == 60000) {
            this.popupData = res.datas;
          } else {
            this.$message.error(res.resp_msg);
          }
        });
    },
    handleClose(done) {
      done();
      this.registerForm = {
        phone: "",
        password: "",
        code: "",
        professionCode: "",
      };
    },
    mobileFocus() {
      //   var icon=document.getElementsByClassName('iconzhanghao');
      this.$refs.account.style.color = "#1458EA";
    },
    mobileBlur() {
      //   var icon=document.getElementsByClassName('iconzhanghao');
      this.$refs.account.style.color = "#9E9FAB";
    },
    async regist() {
      const _this = this;

      if (!this.registerForm.phone) {
        this.$message.error("请输入手机号");
        return;
      }
      if (!this.testPhone(this.registerForm.phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      if (!this.registerForm.password) {
        this.$message.error("请输入密码");
        return;
      }
      if (this.registerForm.password.length < 6) {
        this.$message.error("请输入6~16位字符的密码");
        return;
      }
      if (!this.smsKey) {
        this.$message.error("请获取验证码");
        return;
      }
      if (!this.registerForm.code) {
        this.$message.error("请输入验证码");
        return;
      }
      if (!/^[0-9]*$/.test(this.registerForm.code)) {
        this.$message.error("请输入正确的验证码");
        return;
      }
      if (!this.registerForm.professionCode) {
        this.$message.error("请选择职业");
        return;
      }

      //   if (!this.verification) {
      //     document.getElementById("getCode").click();
      //     this.$message.error("请进行智能验证");
      //     return;
      //   }

      const obj = {
        applisource: "pc",
        password: _this.registerForm.password,
        phoneno: _this.registerForm.phone,
        platform: "pc",
        smsCode: _this.registerForm.code,
        isJson: true,
        professionCode: _this.registerForm.professionCode,
        smsKey: this.smsKey,
      };
      const res = await api_registerPhone(obj);

      if (res.resp_code == 60000) {
        const J = JSON.parse(res.datas);
        this.getAppuserinfo(J.access_token);
        this.GETUSERINFO();
        window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
        this.$message.success({
          showClose: true,
          message: "注册成功",
          type: "success",
        });
        this.$root.registVisible = false;
        this.getPopupInfo();

        this.showCode = true;
      } else if (res.resp_code == 60202) {
        this.isRegist = true;
        this.$message.error(res.resp_msg);
      } else {
        this.$message.error(res.resp_msg);
      }
    },
    //推广码
    closeView() {
      this.showCode = false;

      if (this.popupStatus == 0) {
        this.showQrCode = false;
        this.goReturnUrl();
      } else if (this.popupStatus == 1) {
        this.showQrCode = true;
      }
    },
    jump() {
      this.showQrCode = false;
      this.goReturnUrl();
    },
    userIsRegist(val) {
      this.isRegist = val;
    },
    //返回登录
    goLogin() {
      this.$root.loginVisible = true;
      this.$root.registVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input__inner {
  height: 34px;
  line-height: 34px;
}

/deep/ .el-select .el-input .el-select__caret::before {
  content: "\e78f";
}
/deep/ .el-dialog__headerbtn {
  top: 30px;
  font-size: 19px;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #182c49;
  position: relative;
  z-index: 99999;
}
/deep/ .el-dialog__header {
  padding: 0px;
}
.regist {
  .regist-tit {
    font-size: 20px;
    color: #182c49;
    text-align: center;
    font-weight: bold;
    padding-bottom: 20px;
    border-bottom: 1px solid #e6e9f0;
    margin: 0px 40px;
  }
  .el-dialog__body {
    padding: 35px 20px;
  }
  .hint-login {
    font-size: 12px;
    color: #c0c3c8;
    margin-left: 11px;
    height: 30px;
    line-height: 30px;
  }
}
/deep/.el-button.is-disabled,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-color: #ddd;
  border-color: #ebeef5;
}

.foot-text {
  position: absolute;
  bottom: -35px;
  left: 50px;
  color: #fff;
}
.l-icon {
  margin-top: 30px;
  padding: 0 30px;
  justify-content: space-around;
  display: flex;
  align-items: center;
  position: relative;
  i {
    &:first-child {
      background: #17c444;
      margin-right: 80px;
    }
    &:first-child + i {
      background: #1191ff;
    }
  }
  .iconfont {
    cursor: pointer;
    width: 64px;
    height: 64px;
    display: inline-block;
    line-height: 64px;
    text-align: center;
    color: #fff;
    border-radius: 50%;
    font-size: 28px;
    z-index: 2;
    //   &:first-child {
    //     background: #17C444 url('../assets/images/weixin.png') no-repeat center
    //       center;
    //     background-size: 33px 33px;
    //   }
    //   &:first-child + i {
    //     background: #1191FF url('../assets/images/qq.png') no-repeat center center;
    //     background-size: 22px 22px;
    //   }
  }
  .icon-qq {
    font-size: 21px;
  }
}
.regist {
  //   background: url('../assets/img/bg.png') no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;
  .text-wa {
    position: absolute;
    color: #ffffff;
    top: 35%;
    left: 29%;
    line-height: 33px;
  }

  .container-page {
    width: 1180px;
    margin: 0 auto;
  }
  .box {
    background: #fff;
    border-radius: 2px;
    box-sizing: border-box;
    position: relative;
    .helper {
      display: flex;
      justify-content: space-between;
      width: 320px;
      margin-top: 15px;
      font-size: 16px;
      /deep/ .el-checkbox__label {
        color: #0055f3;
      }
      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #0055f3;
        border-color: #0055f3;
      }
      /deep/ .el-checkbox {
        vertical-align: middle;
      }
      .right {
        color: #8192a8;
        cursor: pointer;
        width: 100%;
        text-align: center;
        font-size: 14px;
        span {
          &:hover {
            color: #0055f3;
          }
        }
      }
    }
    .list {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: column;
      padding-top: 90px;
      .icon {
        color: #8192a8;
        font-size: 18px;
      }
      .puzzle {
        user-select: none;
        // margin-bottom: 20px;
      }
      .lb {
        width: 320px;
        height: 50px;
        border-radius: 40px;
        margin-left: 0;
        margin-top: 20px;
        /deep/ span {
          font-size: 16px;
        }
      }

      .login-btn {
        width: 320px;
        height: 60px;
        border-radius: 40px;
        background-color: #0055f3;
        color: #fff;
        text-align: center;
        line-height: 60px;
        margin-top: 25px;
        cursor: pointer;
        &:hover {
          background-color: rgba(0, 85, 243, 0.12);
        }
        span {
          text-align: center;
          font-size: 16px;
        }
      }
      .register {
        position: absolute;
        top: 300px;
        display: flex;
        align-items: center;
        height: 40px;
        width: 308px;
        border-radius: 4px;
        padding-left: 10px;
        p {
          color: #8192a8;
          font-size: 12px;
        }
        span {
          color: #ff1616;
          font-size: 12px;
          cursor: pointer;
        }
        i {
          color: #ff1616;
        }
      }
      .block {
        width: 340px;
        margin-left: 40px;
      }
      .tit {
        margin-right: 10px;
      }
    }
    .tab {
      text-align: center;
      padding: 0 30px;
      border-bottom: 1px solid #e6e9f0;
      li:first-child {
        // margin-right: 50px;
      }
      li {
        cursor: pointer;
        color: #132c4b;
        font-size: 20px;
        padding-bottom: 20px;
        border-bottom: 4px solid transparent;
        white-space: nowrap;
        display: inline-block;
        margin-left: 23px;
        position: relative;
        &:nth-child(1) {
          &::after {
            display: inline-block;
            content: "";
            width: 1px;
            height: 11px;
            background: #8b8b8b;
            position: absolute;
            right: 6px;
            top: 10px;
          }
        }
        span {
          font-size: 14px;
          display: block;
          transform: translate(-18px);
          font-weight: bold;
        }
      }
      .on {
        color: #1458ea;
        span {
          font-size: 20px;
        }
      }
    }
  }
}
.t {
  color: #c0c3c8;
  text-align: center;
  font-size: 14px;
  margin-top: 17px;
  position: relative;
  width: 75%;
  span {
    display: inline-block;
    position: relative;
    background: #ffffff;
    z-index: 99;
    padding: 0px 15px;
  }
  &::before {
    content: "";
    background-color: #f7f9fc;
    width: 100%;
    height: 1px;
    position: absolute;
    top: 10px;
    left: 0;
  }
}
.check-inp {
  width: 320px;
}

.code-inp {
  width: 200px;
}
/deep/.el-form-item {
  margin-bottom: 20px;
}
/deep/.el-input__inner {
  background-color: #e4e9f3;
}
.hide-check-icon {
  /deep/.el-input__suffix {
    /deep/.el-input__validateIcon {
      display: none;
    }
  }
}
.btn-blue {
  background: #1458ea;
  border: none;
  color: #ffffff;
  transition: all 0.2s linear;
}

.btn-blue:focus,
.btn-blue:hover {
  color: #ffffff;
  border-color: #1458ea;
  background-color: rgba(20, 88, 234, 0.8);
}

/deep/.el-input__inner:focus {
  color: #1458ea;
  border-color: #1458ea;
}
/deep/ .el-input__prefix:focus {
  color: #1458ea;
}

//注册成功弹窗样式
.layout {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  .inner {
    width: 540px;
    height: 666px;
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    h5 {
      text-align: center;
      margin: 40px 0 20px 0;
      position: relative;
      line-height: 40px;
      font-size: 24px;
      span {
        font-size: 24px;
      }
      &::after {
        content: "";
        position: absolute;
        bottom: -20px;
        left: 50%;
        width: 68px;
        height: 4px;
        background-color: #1458ea;
        transform: translateX(-50%);
      }
    }
    > img {
      width: 262px;
      margin: 20px 0;
      margin-top: 40px;
    }
    > p {
      text-align: center;
      color: #c3c6cb;
      position: relative;
      margin: 20px 0;
      font-size: 14px;
      &::before {
        content: "";
        position: absolute;
        display: block;
        width: 100px;
        height: 1px;
        background: #f2f2f2;
        top: 9px;
        left: -100%;
      }
      &::after {
        content: "";
        position: absolute;
        display: block;
        width: 100px;
        height: 1px;
        background: #f2f2f2;
        bottom: 8px;
        right: -100%;
      }
    }
    button {
      width: 180px;
      height: 48px;
      background-color: #1458ea;
      border-radius: 24px;
      border: none;
      color: #fff;
      margin-top: 50px;
      cursor: pointer;
    }
  }
}

//第三方登录样式
.thirdLogin {
  box-sizing: border-box;
  float: right;
  height: 100px;
  overflow: hidden;
  > span {
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    cursor: pointer;
  }
  .iconfont {
    cursor: pointer;
    width: 55px;
    height: 55px;
    display: inline-block;
    vertical-align: middle;
    line-height: 55px;
    text-align: center;
    color: #fff;
    border-radius: 50%;
    &.icon-weixin {
      background: #24db5a url("../assets/images/weixin.png") no-repeat center
        center;
      background-size: 28px 28px;
    }
    &.icon-qq {
      margin-left: 70px;
      background: #1bc1fa url("../assets/images/qq.png") no-repeat center center;
      background-size: 22px 22px;
    }
  }
}

//微信注册二维码弹窗样式
.wxQrCode {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: #fff;
  #register_container {
    padding: 50px 50px 0;
    margin-left: 15px;
  }
  .close {
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    height: 50px;
    background: #f2eff7 url("../assets/images/left.png") no-repeat 10px 10px;
    background-size: 20px;
    border-bottom-right-radius: 100%;
    cursor: pointer;
  }
}
/deep/ .el-dialog__headerbtn{
     z-index: 9 !important;
}
</style>
<style>
 .wxQrCode .el-dialog__headerbtn{
     top: 42px !important;
    
 }
 .circle{
     position: absolute;
     width: 50px;
     height: 50px;
     right: 10px;
     background: #fff;
     z-index: 99;
 }
</style>